import { render } from "./ConfirmationReferenceInput.vue?vue&type=template&id=205a9c14"
import script from "./ConfirmationReferenceInput.vue?vue&type=script&lang=js"
export * from "./ConfirmationReferenceInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__